import React from "react";
import styled from "styled-components";
import Button from "../../Common/Components/Button";
import { Link } from "react-router-dom";
function EmptyTabInfo(props) {
  const { description, btntext, url, className } = props;
  return (
    <WrapperStyle className={`${className ?? ""}`}>
      <div className="inner-wrapper">
        <p className="description">{description}</p>
        <div className="text-center">
          {btntext && url ? (
            <Link to={url}>
              <Button value={btntext} />
            </Link>
          ) : btntext ? (
            <Button value={btntext} />
          ) : null}
        </div>
      </div>
    </WrapperStyle>
  );
}

export default EmptyTabInfo;

const WrapperStyle = styled.div`
  display: flex;
  justify-content: center;
  .inner-wrapper {
    width: 100%;
    margin-top: 50px;
    .description {
      text-align: center;
      font-size: 24px;
      color: #424b50;
      line-height: 1.175;
      font-family: "Roboto Slab", serif;
      font-weight: bold;
      /* min-width: 550px;
      text-align: left; */
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 22px;
      }
    }
  }
`;
